import React, { useState } from 'react';

const VendorSignup = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    zipcode: ''
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    // Use email as username for signup
    const payload = {
      ...form,
      username: form.email,
      usertype: 3
    };
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage('Sign up successful! Verification email sent.');
        setTimeout(() => {
          window.location.href = '/signin'; // Redirect to login page
        }, 1500); // Wait 1.5 seconds before redirecting
      
      } else {
        setMessage(data.message || 'Sign up failed.');
      }
    } catch (err) {
      setMessage('Sign up failed.');
    }
  };


  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <h2 style={styles.title}>STEM Coach Sign Up</h2>
        <input
          style={styles.input}
          type="text"
          name="firstName"
          placeholder="First Name"
          value={form.firstName}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={form.lastName}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="zipcode"
          placeholder="Zip Code"
          value={form.zipcode}
          onChange={handleChange}
          required
        />
        <button style={styles.button} type="submit">Sign Up</button>
        {message && <div style={styles.message}>{message}</div>}
      </form>
      <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '15px' }}>
        If you have an account, please{' '}
        <a href="/signin" style={{ color: '#4078c0', textDecoration: 'underline' }}>
          log in
        </a>
        .
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  title: {
    marginBottom: '16px',
    color: '#4078c0',
    fontSize: '1.5rem',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  button: {
    padding: '10px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
  },
  message: {
    marginTop: '16px',
    color: '#4078c0',
    fontSize: '1rem',
  },
};

export default VendorSignup;